import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { DialogProvider } from '@keobook/ui';
import { AuthProvider } from './lib/auth';
import { GuidedRoute } from './components/GuidedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SignIn } from './pages/SignIn';
import { SignUp } from './pages/SignUp';
import { ForgotPassword } from './pages/ForgotPassword';
import { Onboarding } from './pages/Onboarding';
import { EngagementLetterPage } from './pages/EngagementLetter';
import { Dashboard } from './pages/Dashboard';
import { Reports } from './pages/Reports';
import { Activity } from './pages/Activity';
import { GeneralLedger } from './pages/GeneralLedger';
import { Invoicing } from './pages/Invoicing';
import { PublicInvoice } from './pages/PublicInvoice';
import { Documents } from './pages/Documents';
import { Settings } from './pages/Settings';
import { Reactivate } from './pages/Reactivate';
import { Referral } from './pages/Referral';
import { InviteAccept } from './pages/InviteAccept';
import { DemoEntry } from './pages/Demo';
import { Periods } from './pages/Periods';
import { Accounts } from './pages/Accounts';
import { Admin } from './pages/Admin';

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <DialogProvider>
          <AuthProvider>
            <Routes>
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/demo" element={<DemoEntry />} />
              {/* Public hosted invoice — no auth, token is the auth. */}
              <Route path="/inv/:token" element={<PublicInvoice />} />
              {/* Collaborator invite acceptance — public so a logged-out invitee
                  can land here from the email; the page drives sign-in + OTP. */}
              <Route path="/invite" element={<InviteAccept />} />
              <Route element={<GuidedRoute />}>
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/engagement-letter" element={<EngagementLetterPage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/activity" element={<Activity />} />
                <Route path="/ledger" element={<GeneralLedger />} />
                <Route path="/invoicing" element={<Invoicing />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/periods" element={<Periods />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/reactivate" element={<Reactivate />} />
                <Route path="/referral" element={<Referral />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </DialogProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
